import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer1Ekspertyzy from "../../components/offer/1ekspertyzy";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Ekspertyzy dendrologiczne i ocena stanu drzew | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Ekspertyzy dendrologiczne i ocena stanu drzew | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Profesjonalne ekspertyzy dendrologiczne i ocena stanu zdrowotnego drzew przed budową lub wycinką. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Ekspertyzy dendrologiczne i ocena stanu drzew | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Profesjonalne ekspertyzy dendrologiczne i ocena stanu zdrowotnego drzew przed budową lub wycinką. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1Ekspertyzy />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
